<div id="lecture-cab-form">
  <mat-card class="mat-elevation-z center-content">
    <h2>Ajout fichier(s)</h2>
    <p>Choisissez un ou des fichiers à rajouter :</p>
    <input #fileUpload (change)="onFileSelected()" type="file" multiple id="file" style="display:none;">
    <div class="file-upload">
      <button mat-stocked-button (click)="fileUpload.click()">
        Ajout fichier(s)
      </button>
      {{files.length > 0 ? files.length + " fichier(s)" : "Aucun fichier choisi"}}
    </div>
    <div *ngFor="let element of files" class="file-selected">
      <div class="file-selected-name"><b>{{element.name}}</b></div>
      <button mat-icon-button class="file-selected-button">
        <mat-icon color="red" class="file-selected-icon" (click)="deleteFile(element)">close</mat-icon>
      </button>
    </div>
    <mat-card-actions>
      <button mat-raised-button [disabled]="files.length == 0 || loading" (click)="checkLecture()"
        class="button-spinner{{loading?'-loading':''}}">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>Valider
      </button>
    </mat-card-actions>
  </mat-card>
</div>